<section class="sx-dialog__small">
  <header class="sx-dialog__content">
    <h2 class="sx-dialog__heading h3">{{ 'core.reloadprompt.title' | translate }}</h2>
  </header>
  <div class="sx-dialog__content" [innerHtml]="'core.reloadprompt.message' | translate "></div>
  <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
      <button class="sx-button sx-button--wide sx-button--magenta" mat-button (click)="hardRefresh()">{{ 'core.reloadprompt.reload_button' | translate }}</button>
  </div>
</section>